import React from "react";

const AgentsFinalCTASection = () => {
  return (
    <section className="final-cta">
      <h3>Start Exploring with FinTorro AI</h3>
      <p>Let our AI agents guide your next smart trading move. Fast, fun, and free to try.</p>
      <button className="cta-button" onClick={() => window.location.href = "/agent-access"}>
        Try AI Agents Now
      </button>
    </section>
  );
};

export default AgentsFinalCTASection;
